import React, { useEffect, useState } from 'react'
import { IProps } from './types'
import { useStyles } from '../../style/styles'
import { AppBar, Box, IconButton, Menu, MenuItem, Toolbar, Tooltip, Typography } from '@mui/material'
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone'
import { MessagingConstants } from '../../lib/enums'
import messagingService from '../../services/MessagingService'
import { connectToMessagingWebsocket, truncateText, WEBSOCKET_CONNECTED_MESSAGE, WEBSOCKET_PRESENCE_MESSAGE } from '../../lib/messageUtils'
import CustomTooltip from '../CustomTooltip'

function Navbar(props: IProps) {
    const classes = useStyles()
    const {
        receiver,
        job,
        userType,
        username,
        onEndConversation,
        isEndedConversation,
        token,
        connections,
        platform,
        onTimezoneClick,
        onNotificationClick,
        userArn,
        endOrReenableActionDoer,
        onMinimizeChat,
        channelMetadata,
        websocketConnection,
        hasSmsOptedIn
    } = props
    const isMinimized = false
    const onMinimize = () => {}
    const onExpandPanel = () => {}
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const isMenuOpen = Boolean(anchorEl)
    const [isExpanded, setIsExpanded] = useState(false)
    const [status, setStatus] = useState<boolean>(false)

    const displayName = receiver?.info?.first_name && receiver?.info?.last_name ? `${receiver?.info?.first_name} ${receiver?.info?.last_name}` : username

    /* TJSKR-3131 ONLINE PRESENCE */
    useEffect(() => {
      if(websocketConnection && websocketConnection?.connectToWebsocket && process.env.REACT_APP_SHOW_PRESENCE === 'true') {
        const handlePresenceMessage = (message: any) => {
          if(message.type == WEBSOCKET_PRESENCE_MESSAGE) {
            const isMatchingUser = message.users.some((user: string) => user.split("+")[0] === receiver?.userArn)
            isMatchingUser ? setStatus(true) : setStatus(false)
          }
        }

        connectToMessagingWebsocket(websocketConnection, handlePresenceMessage)
      }
    }, [websocketConnection])

    const handleChatClose = () => {
      window.parent.postMessage({ type: 'MESSAGING_CLOSE_IFRAME', token, candidateId: job?.candidate_id  }, '*');
      messagingService.close()
    }

    const handleMinimize = () => {
      onMinimizeChat()
    }

    const handleEndConversation = () => {
      onEndConversation(true)
      setAnchorEl(null)
    }

    const handleReEnableEndConversation = () => {
        onEndConversation(false)
        setAnchorEl(null)
    }

    const handleTimezone = () => {
      onTimezoneClick()
      setAnchorEl(null)
    }

    const handleNotifications = () => {
      onNotificationClick()
      setAnchorEl(null)
    }

    const getEllipsisIcon = () => {
      if(platform === 'mobile') {
        return connections?.isBlocked || connections?.isBlockedLink ? "/images/ellipsis-dark-disabled.svg" : "/images/ellipsis-dark.svg"
      } else {
        return connections?.isBlocked || connections?.isBlockedLink ? "/images/ellipsis-h-unsent.svg" : "/images/ellipsis-h.svg"
      }
    }

    const getCallIcon = () => {
      return platform !== 'mobile' && receiver?.mobile?.trim() ? "/images/Call.svg" : "/images/Call_Blocked.svg"
    }

    const handleCallIcon = async () => {
      const phone = receiver?.mobile
      if(phone?.replace(/[\s()]/g, '').trim()) {
        const callLink = `tel:${phone}`
        window.location.href = callLink
      }
    }

    const renderMenu = (
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{vertical: 'bottom', horizontal: 'right' }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={isMenuOpen}
        onClose={() => {setAnchorEl(null)}}
        sx={{
          zIndex: 9999,
          fontSize: '14px',
          fontFamily: 'Poppins',
          lineHeight: '22px',
          padding: '4px, 1px, 4px, 1px'
        }}
      >
        {
          isEndedConversation ? (
          <MenuItem
            disabled={endOrReenableActionDoer == userArn ? false : true}
            onClick={handleReEnableEndConversation}
            sx={{ padding: '8px, 16px, 8px, 16px'}}
            >
            < Typography sx={{
              color: 'var(--primary-default-2-f-86-dd, #2F86DD)',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '22px',
              padding: '8px, 16px, 8px, 16px'
            }} >
              Re-Enable Conversation
            </Typography>
          </MenuItem>
          ) : (
          <MenuItem
            onClick={handleEndConversation}>
            <Typography
              sx={{
                color: 'var(--danger-hover-focused-active-f-42-a-3-f, #F42A3F)',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '22px',
              }}
            >
              End Conversation
            </Typography>
          </MenuItem>
          )
        }

        { userType.toLowerCase() === 'jobseeker' && (
            <MenuItem onClick={handleNotifications}>
              <Typography
                sx={{
                  color: 'var(--primary-text-color, #000)',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '22px',
                }}
              >
                Notifications
              </Typography>
            </MenuItem>
          )
        }

        <MenuItem
          onClick={handleTimezone}
        >
          <Typography
            sx={{
              color: 'var(--primary-text-color, #000)',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '22px',
            }}
          >
            Settings
          </Typography>
        </MenuItem>
      </Menu>
    )
    const fColor = platform === 'mobile' ? 'inherit' : 'default'
    return (
        <>
        <div
          className={classes.chatNavbar}>
            <AppBar
                position="static"
                sx={{
                  // borderRadius:  platform == 'mobile' ? 'none': '8px 8px 0px 0px',
                  borderRadius: 'none',
                  boxShadow: 'none',
                  border: platform == 'mobile' ? '0.5px solid #eae8e4' : 'none',
                  // border: 'none',
                  backgroundColor: platform == 'mobile' ? 'white' : '#2f86dd',
                  color: fColor,
                  height: '100%'
                }}>
                <Toolbar
                    sx={{
                    height: '100%',
                    padding: '16px 16px 16px 24px',
                    borderRadius: 'inherit',
                    backgroundColor: 'inherit',
                    color: 'inherit',
                    display: 'flex', 
                    alignItems: 'center'
                }}>
                  {/* MSGT-4126:  Show an indicator to Recruiters when the Jobseeker is opted-in to SMS. */}
                  { hasSmsOptedIn && userType === 'RECRUITER' && (
                    <CustomTooltip title="User opted in to SMS notifications. Messages are likely to reach them quickly." placement="top">
                      <IconButton
                        size="small"
                        sx={{
                          color: '#FFD700',
                          padding: '4px',
                        }}
                      >
                        <PhoneIphoneIcon fontSize="small" />
                      </IconButton>
                    </CustomTooltip>
                  )}
                  <Box sx={{ flexGrow: 1, maxWidth: isMinimized ? '150px':'auto' }}>
                      {/* <Tooltip title={displayName} arrow> */}
                       <CustomTooltip title={displayName} placement="top">
                        <Typography
                          sx={{
                            fontSize: '16px',
                            fontWeight: '500',
                            fontFamily: 'Poppins',
                            color: platform === 'mobile' ? '#000' : '#fff',
                            // marginBottom: '2px',
                            lineHeight: '20px',
                            paddingLeft: platform === 'mobile' ? '15px' : '5px'
                          }}
                        >
                          {truncateText(displayName, 20)}
                        </Typography>
                      </CustomTooltip>
                      {/* TJSKR-3352 Feature flag ONLINE PRESENCE IN PROD */}
                      { process.env.REACT_APP_SHOW_PRESENCE === 'true' && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', paddingLeft: platform === 'mobile' ? '15px' : '0' }}>
                          <Box
                            sx={{
                              width: '6px',
                              height: '6px',
                              borderRadius: '50%',
                              backgroundColor: status ? '#4CAF50' : '#9E9E9E',
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: '11px',
                              fontWeight: '400',
                              fontFamily: 'Poppins',
                              color: platform === 'mobile' ? '#666' : 'rgba(255, 255, 255, 0.8)',
                              lineHeight: '14px',
                            }}
                          >
                            {status ? 'Online' : 'Offline'}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                    <Box sx={{ display: { xs: 'flex', md: 'flex', gap: '0px' }}}>
                        {
                        !isMinimized && (
                          <>
                            { platform != 'mobile' ? (
                              <>
                                <IconButton
                                  onClick={handleMinimize}
                                  sx={{width:'38px', height: '38px', '&:hover': { cursor: 'pointer' }}}
                                  color="inherit"
                                  >
                                  <img
                                    src={"/images/compress-alt.svg"}
                                    alt={"Minimize"}
                                    width={18}
                                    height={20}
                                  />
                                </IconButton>
                                <IconButton
                                  color="inherit"
                                  onClick={handleCallIcon}
                                  sx={{width:'38px', height: '38px', '&:hover': { cursor: 'pointer' }}}
                                  disabled ={platform === "mobile" || !receiver?.mobile?.trim()}
                                  data-toggle="tooltip" data-placement="right" title="" data-original-title="Call this candidate"
                                >
                                  <img
                                    src={getCallIcon()}
                                    alt="Call this candidate"
                                    width={18}
                                    height={20}
                                  />
                                </IconButton>
                              </>
                            ) : null }
                              <IconButton
                                  onClick={(e) => { setAnchorEl(e.currentTarget) }}
                                  sx={{width:'38px', height: '38px', '&:hover': { cursor: 'pointer' }}}
                                  disabled={connections?.isBlocked || connections?.isBlockedLink}
                              >
                                <img
                                  src={getEllipsisIcon()}
                                  alt="View more options"
                                  width={18}
                                  height={20}
                                />
                              </IconButton>
                            </>
                        )
                        }
                        {platform != 'mobile' ? (
                        <IconButton
                            onClick={handleChatClose}
                            sx={{width:'38px', height: '38px', '&:hover': { cursor: 'pointer' }}}
                            color="inherit"
                            id="closeButton"

                        >
                        <img
                            src="/images/times.svg"
                            alt="Close chat"
                            width={18}
                            height={20}
                        />
                        </IconButton>
                        ): null}
                    </Box>
                </Toolbar>
            </AppBar>
              <>{renderMenu} </>
          </div>
        </>
    )
}

export default Navbar
